const MAP = {
  RECIBIDO: "st-recibido",
  "EN ANÁLISIS": "st-analisis",
  TERMINADO: "st-terminado",
};

export function StatusPill({ status }) {
  const cls = MAP[status] || "st-recibido";
  return (
    <span className={`ddp-status ${cls}`} data-testid="case-status">
      <span className="dot" />
      {status}
    </span>
  );
}

export function PositionChip({ position }) {
  if (!position) return null;
  const p = position.toLowerCase();
  const cls = p.includes("verde") ? "pos-verde" : p.includes("mbar") || p.includes("ambar") ? "pos-ambar" : "pos-rojo";
  return (
    <span className={`pos-chip ${cls}`} data-testid="result-position">
      {position}
    </span>
  );
}
